var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-chip',{staticClass:"ma-2",attrs:{"color":_vm.spanClass()}},[_vm._v(" "+_vm._s(_vm.spanText())+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }